export default "__VITE_ASSET__DiCVAU4W__"